import Relay from 'react-relay';
import type { EditorTarget } from './FlowTestResultView';

export type CreateDerivedTestMutationProps = {
    source: EditorTarget;
    name?: string;
    reason?: string;
};

export default class CreateDerivedTestMutation extends Relay.Mutation<CreateDerivedTestMutationProps, any> {
    private mutationProps: CreateDerivedTestMutationProps;

    constructor(props: CreateDerivedTestMutationProps) {
        super(props as any);
        this.mutationProps = props;
    }

    getMutation() {
        return Relay.QL`mutation {createDerivedTestInvocation}`;
    }

    getFatQuery() {
        return Relay.QL`
            fragment on CreateDerivedTestInvocationPayload {
                success
                conflict
                error
                testInvocation { id realId name version organisation_id flow_id }
            }
        `;
    }

    getConfigs() {
        // This creates a new node. Never use FIELDS_CHANGE with the source's node id.
        return [{
            type: 'REQUIRED_CHILDREN',
            children: [Relay.QL`
                fragment on CreateDerivedTestInvocationPayload {
                    success
                    conflict
                    error
                    testInvocation { id realId name version organisation_id flow_id }
                }
            `],
        }];
    }

    getVariables() {
        const { source, name, reason } = this.mutationProps;
        return {
            sourceTestInvocationId: source.realId || source.id,
            sourceVersion: source.version,
            name,
            reason,
        };
    }
}
